"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAll = getAll;
exports.getAllBySocieteId = getAllBySocieteId;
exports.getAllActif = getAllActif;
exports.getAllActifBySocieteId = getAllActifBySocieteId;
exports.getById = getById;
exports.update = update;
exports.insert = insert;
exports.deleteById = deleteById;
exports.bulkDelete = bulkDelete;

var _request = _interopRequireDefault(require("@/helpers/request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAll() {
  return (0, _request.default)({
    url: '/secteur_geo',
    method: 'get'
  });
}

function getAllBySocieteId(id) {
  return (0, _request.default)({
    url: '/secteur_geo/societe/' + id,
    method: 'get'
  });
}

function getAllActif() {
  return (0, _request.default)({
    url: '/secteur_geo/actif',
    method: 'get'
  });
}

function getAllActifBySocieteId(id) {
  return (0, _request.default)({
    url: '/secteur_geo/actif/societe/' + id,
    method: 'get'
  });
}

function getById(id) {
  return (0, _request.default)({
    url: '/secteur_geo/' + id,
    method: 'get'
  });
}

function update(id, data) {
  return (0, _request.default)({
    url: '/secteur_geo/' + id,
    method: 'put',
    data: data
  });
}

function insert(data) {
  return (0, _request.default)({
    url: '/secteur_geo',
    method: 'post',
    data: data
  });
}

function deleteById(id) {
  return (0, _request.default)({
    url: '/secteur_geo/' + id,
    method: 'delete'
  });
}

function bulkDelete(ids) {
  return (0, _request.default)({
    url: '/secteur_geo/' + ids,
    method: 'delete'
  });
}